import Vue from 'vue'
import Vuex from 'vuex'
import i18n from './i18n'
import Api from '@/api'

Vue.use(Vuex)
var moment = require('moment');

export default new Vuex.Store({
  state: {
    indicatorList: [],
    nodeInfo: {},
    nodeFilters: {},
    compareNodeInfo: {},
    shareURL: window.location,
    redirectOrigin: null //para cuando hay redirects
  },
  mutations: {
    setIndicatorList (state, data) {
      return state.indicatorList = data
    },
    setNodeInfo (state, data) {
      return state.nodeInfo = data
    },
    setNodeFilters (state, data) {
      return state.nodeFilters = data
    },
    setRedirectOrigin (state,data) {
      return state.redirectOrigin = data
    },
    setShareURL (state, url) {
      return state.shareURL = url
    },
    setCompareNodeInfo (state, data) {
      return state.compareNodeInfo = data
    },
  },
  actions: {
    loadIndicatorList (context, params) {
      return Api.getIndicatorList().then((result) => {
        context.commit('setIndicatorList', result)
      }).catch((err) => {
        console.log(err)
      });
    },
    loadNodeInfo (context, params) {
      console.log("getting node info")
      return Api.getNodeInfo(params).then((result) => {
        console.log("NodeInfo set to ",result.glk)
        return context.commit('setNodeInfo', result)
      }).catch((err) => {
        console.log(err)
      });
    },
    loadNodeFilters (context, params) {
      return Api.getNodeFilters(params).then((result) => {
        context.commit('setNodeFilters', result)
      }).catch((err) => {
        console.log(err)
      });
    },
    setRedirectOrigin (context, data) {
      return context.commit('setRedirectOrigin', data)
    },
    loadCompareNodeInfo (context, params) {
      return Api.getNodeInfo(params).then((result) => {
        return context.commit('setCompareNodeInfo', result)
      }).catch((err) => {
        console.log(err)
      });
    },
  },
  getters: {
    dataCurrentYear: state => {
      return moment(state.nodeInfo.lastUpdate).format('Y')
    }
  },
  modules: {
    i18n
  }
})
